import React, { useState } from "react";
import { InputComponent } from "../../common/InputComponent/InputComponent";
import * as Yup from "yup"
import { useFormik, FormikHelpers } from "formik";
import { toast } from 'react-toastify';
import Divider from "../../common/Divider";
import { useRecoilState } from "recoil";
import UserState from "../../../recoil/UserState";
import { useNavigate } from "react-router-dom";
import { socialSignIn } from "../../../services/common";
import Google from "../../common/icons/Google";
import Facebook from "../../common/icons/Facebook";
import { emailLogin } from "../../../services/api";
import Twitter from "../../common/icons/Twitter";

interface Values {
  email: string,
  password: string,
}

interface MsgObject {
  Msg: string,
  Status: string
}

const loginSchema = () => Yup.object().shape({
  email: Yup.string().email("Email must be valid").required("Email is required"),
  password: Yup.string().required("Password is required"),
})

const Login: React.FC = () => {

  const [loginMsg, setLoginMsg] = useState<MsgObject>({ Msg: '', Status: "" })
  const navigate = useNavigate();
  const [user, setUser] = useRecoilState(UserState)
  const [data, setData] = useState({
    email: "",
    password: "",
  });

  const showToast = () => {
    toast.error('Error! Wrong email or password.');
  };

  const handleLogin = async (values: Values, { resetForm }: FormikHelpers<Values>) => {
    let res : any = await emailLogin(values)
    if(res.data.data.access_token){
      setUser({ ...user, isAuthenticated: true })
      navigate("/")
    }
    else {
      setLoginMsg({ Msg: res.data.message, Status: 'failed' })
    }
  };

  const handleSocialLogin = async (socialMedia: string) => {
    let res: any = await socialSignIn(socialMedia)
    if (res.access_token) {
      setUser({ ...user, isAuthenticated: true })
      navigate("/")
    }
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: ""
    },
    validationSchema: loginSchema,
    validateOnChange: false,
    onSubmit: handleLogin
  })

  return (
    <div className="min-h-screen flex">
      <div className="flex-1 flex flex-col">
        <div className="p-2 ml-6">
          <div className="w-22 py-2 ml-6">
            <img src="/images/logo.png" alt="taotensor" />
          </div>
        </div>
        <div className="flex justify-center items-center flex-1">
          <div className="px-12 min-w-500">
            <form onSubmit={formik.handleSubmit}>
              <div className="flex items-center mb-3">
                <h4 className="custom-font text-4xl text-mid-gray">Sign In</h4>
              </div>
              <div className="pt-4 flex flex-col">
                <InputComponent
                  type="text"
                  value={formik.values.email}
                  name="email"
                  error={formik.errors.email}
                  showErrorMessage
                  onChange={formik.handleChange}
                  labelText={"Email"}
                />
                <InputComponent
                  name="password"
                  type="password"
                  value={formik.values.password}
                  error={formik.errors.password}
                  showErrorMessage
                  containerClassName={"my-4"}
                  onChange={formik.handleChange}
                  labelText={"Password"}
                />
                <p className="text-sm text-darker-gray cursor-pointer hover:text-blue" onClick={() => navigate("/forget-password")}>Forget Password?</p>
                <button type="submit" className="mt-4 custom-font bg-primary rounded-full border-1 border-black text-button-text p-1 hover:bg-secondary hover:text-button-text-hover transition duration-300 ease-in-out">
                  Sign In
                </button>
                {loginMsg.Msg && loginMsg.Msg != '' && <p className={`text-sm pt-2 ${loginMsg.Status == 'success' ? 'text-green' : 'text-red'}`}>{loginMsg.Msg}</p>}
                <p className="text-sm text-darker-gray pt-4">Don`t have an account? <span className="cursor-pointer hover:text-blue" onClick={() => navigate("/signup")}>Sign Up</span></p>
              </div>
            </form>
            <Divider containerClassName="my-4" text="or" />
            <div className="w-full flex flex-col">
              <button onClick={() => handleSocialLogin('google')} className="flex justify-center align-center mb-4 custom-font bg-secondary rounded-full border-1 border-black text-button-text-hover py-1 hover:bg-primary hover:text-button-text transition duration-300 ease-in-out">
                <Google /> <span className="pl-2">Sign In with Google</span>
              </button>
              <button onClick={() => handleSocialLogin('twitter')} className="flex justify-center align-center custom-font bg-secondary rounded-full border-1 border-black text-button-text-hover p-1 hover:bg-primary hover:text-button-text transition duration-300 ease-in-out">
                <Twitter/> <span className="pl-2">Sign In with Twitter</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-1 flex justify-center align-center">
        <img src="/images/login_image.png" alt="taotensor" className="object-contain" />
      </div>
    </div>
  )
};

export default Login;